import { type UseMutationOptions, type UseMutationResult, useMutation } from '@tanstack/react-query';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';

import {
  type THideOfferWebsiteRequest,
  type THideOfferWebsiteResponse_1,
} from '@/repositories/generated/shared/hidden-objects/v1/hide-offer-website';

import { type QueryError, getQueryKey } from './internal/config';
import { fetchAddFavoriteService } from './internal/fetchService';

export function useHideOfferMutation<TContext = unknown>(
  options?: Omit<
    UseMutationOptions<THideOfferWebsiteResponse_1, QueryError, THideOfferWebsiteRequest, TContext>,
    'mutationKey' | 'mutationFn'
  >,
): UseMutationResult<THideOfferWebsiteResponse_1, QueryError, THideOfferWebsiteRequest, TContext> {
  const context = useQueryStateAppContext();

  return useMutation<THideOfferWebsiteResponse_1, QueryError, THideOfferWebsiteRequest, TContext>({
    mutationFn: parameters => fetchAddFavoriteService(context, parameters),
    mutationKey: getQueryKey(),
    ...options,
  });
}
